module.exports = __webpack_public_path__ + "img/combo-package.2bbc5862.png";